import { DEVICE_TYPE_COUNT_COLORS } from "./constants";

export function getPercentagesBasedOnKey(data: any, key: any) {
  const otherPercentages = data?.percentage_delta?.[key] || {
    day: 0,
    week: 0,
    month: 0,
  };
  const yearlyPercentage = data?.["year_percentage_delta"]?.[key] ?? 0;

  return { ...otherPercentages, year: yearlyPercentage };
}

export function getPlatFormType(activePlateform: any, activeFeature: any) {
  if (activeFeature === "launch") {
    return activePlateform === "iOS" ? "ios" : activePlateform;
  }
  return activePlateform === "web" ? "desktop" : activePlateform;
}

export function getCountDataFinal(data: any) {
  if (!data) return;
  const agregatedData = data
    ?.filter((item: any) => item.deviceType)
    ?.map((item: any) => {
      if (item.deviceType) {
        return {
          ...item,
          fill: DEVICE_TYPE_COUNT_COLORS[item.deviceType.toLowerCase()],
          percentage: item.percentage,
        };
      }
      return null;
    });
  return agregatedData;
}

export function calculateContainerProperties({ width, screens }: any) {
  const gap = width / 100;

  let col = 3;
  let colWidth = 0;

  if (screens.lg) {
    col = 3;
  }

  if (screens.xl) {
    col = 5;
  }

  if (screens.xxl) {
    col = 5;
  }

  colWidth = (width - (col - 1) * gap) / col;

  return { col, gap, width, colWidth };
}
